import { graphql } from 'gatsby'
import React from 'react'

import CompletePage from '../containers/Support/CompletePage'

const Support = ({ data }) => {
  return <CompletePage {...data.portal} />
}

export default Support

export const query = graphql`
  query SupportCompleteQuery ($firebaseId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
      ...SupportData
    }
  }
`
